export default __webpack_public_path__ + "static/media/hörtest-avatar-03.da70954b.svg";